module.exports = __webpack_public_path__ + "static/media/digital-card-info.551797fa.svg";